import gql from 'graphql-tag';

export const add = gql`mutation CreatePort($port: PortInput!) {
    createPort(port: $port) {
        id
        name

        country {
            id
            name
        }
    }
}`;

export const edit = gql`mutation EditPort($id: ID!, $port: PortInput!) {
    editPort(id: $id, port: $port) {
        id
        name

        country {
            id
            name
        }
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/mutations/port.js